import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { LayoutState } from '../../store';
import { selectIsHeaderVisible } from '../../store/selectors/layout.selector';
import { LayoutService } from 'src/app/core/services/layout.service';

@Component({
  selector: 'app-base',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss']
})
export class BaseLayoutComponent implements OnInit {
  public headerShowHide: boolean;
  currentFormat: string;
  constructor(private store: Store<LayoutState>, private layoutService: LayoutService) {
    this.headerShowHide = true;
  }
  ngOnInit() {
    this.globalUserPrefSettings();
    this.store.pipe(select(selectIsHeaderVisible)).subscribe(res => {
      this.headerShowHide = res;
    });
  }

  globalUserPrefSettings() {
    this.layoutService.getUserPreference().subscribe((myPreferenceResponse: any) => {
      
      this.currentFormat = myPreferenceResponse.GlobalizationDateFormat;
      if (this.currentFormat === 'DD/MM/YYYY') {
        this.currentFormat = 'dd/MM/yyyy';
      } else if (this.currentFormat === 'YYYY/MM/DD') {
        this.currentFormat = 'yyyy/MM/dd';
      } else if (this.currentFormat === 'MM-DD-YYYY') {
        this.currentFormat = 'MM-dd-yyyy';
      } else if (this.currentFormat === 'DD-MM-YYYY') {
        this.currentFormat = 'dd-MM-yyyy';
      } else if (this.currentFormat === 'YYYY-MM-DD') {
        this.currentFormat = 'yyyy-MM-dd';
      } else if (this.currentFormat === 'MM.DD.YYYY') {
        this.currentFormat = 'MM.dd.yyyy';
      } else if (this.currentFormat === 'DD.MM.YYYY') {
        this.currentFormat = 'dd.MM.yyyy';
      } else if (this.currentFormat === 'YYYY.MM.DD') {
        this.currentFormat = 'yyyy.MM.dd';
      } else {
        this.currentFormat = 'MM/dd/yyyy';
      }
      localStorage.setItem('userPrefDateFormat', this.currentFormat); 
    });
  }
}
